import { PrimariaApi } from "@uxland/primary-shell";

type LocaleKeys<T> = T extends object
  ? {
      [K in keyof T]: `${K & string}` | (T[K] extends object ? `${K & string}.${LocaleKeys<T[K]>}` : never);
    }[keyof T]
  : never;

export type ActivityHistoryLocales = LocaleKeys<(typeof locales)[typeof defaultLang]["activity-history"]>;

const defaultLang = "ca";

let pluginLocaleManager;

export const initializeLocalization = async (api: PrimariaApi) => {
  pluginLocaleManager = await api.createLocaleManager(locales);
};

export const translate = (path: ActivityHistoryLocales) => {
  if (pluginLocaleManager) return (pluginLocaleManager as any).translate(path);
  return path;
};

export const locales = {
  ca: {
    "activity-history": {
      activityHistory: "Històric d’activitat",
      importer: {
        title: "Històric d’activitat",
        searchPlaceholder: "Escriu per cercar",
        selectAll: "Seleccionar tot",
        filters: "Filtres:",
        today: "Avui",
        diagnostics: "Diagnòstics associats",
        noResults: "Sense resultats",
      },
      search: "Cercar",
      groupedView: "Visió agrupada",
      maximize: "Ampliar",
      deleted: "Eliminat",
      goToDate: "Anar a data",
      busyEntriesLoading: "Carregant totes les entrades",
      noResults: "Sense resultats. Modifica la cerca",
      noData: {
        title: "Sense dades",
        description: "No existeix informació per a mostrar",
      },
      isGrouping: "Creant agrupacions i preparant les dades...",
      searchBarResults: "Resultats per",
      actions: {
        cronogram: "Cronograma",
        exportPdf: "Exportar PDF",
        moreOptions: "Més opcions",
        refresh: "Actualitzar",
        entryLegend: "Llegenda entrades",
        maximizeButton: "Botó maximitzar",
        minimizeButton: "Botó minimitzar",
        menuButton: "Botó menu",
      },
      modal: {
        selectExportOption: "Tria una opció d'exportació",
        allActivityHistory: "Tot l’històric d’activitat",
        onlyAppliedFilters: "Només amb filtres aplicats",
        selectDateRange: "En el cas que sigui necessari, selecciona un rang de dates",
        helpText:
          "Sense seleccionar data, s'aplicarà la de la primera entrada. Sense seleccionar data de fi, s'aplicarà la de l'última entrada.",
        startDate: "Data Inici",
        endDate: "Data Fi",
        cancel: "Cancel·lar",
        export: "Exportar",
      },
      filters: {
        filters: "Filtres",
        searchFilter: "Cercar filtre",
        ownFilters: "Els meus",
        rellevantFilters: "Rellevants",
        episode: "Episodi",

        dates: "Dates",
        diagnoses: "Diagnòstics",
        clinicalCourseType: "Tipus Curs Clínic",

        selected: "seleccionats",
        applyFilters: "Aplicar filtres",

        deleted: "Eliminats",
      },
      tooltips: {
        subjective: "Subjectiu",
        UPconfidenciality: "Confidencialitat: per a la meva UP",
      },
      grouped: {
        clinicalCourses: "Cursos clínics",
        activities: "Activitats",
        variablees: "Variables",
        prescriptions: "Prescripcions",
      },
      chipHeader: {
        selection: "Selecció:",
        without: "Sense",
        cleanFilters: "Netejar filtres",
      },
      error: {
        general: {
          title: "Hi ha hagut un problema durant la càrrega de contingut. Actualitza la pàgina o torna-ho a provar més tard.",
          refresh: "Actualitzar pàgina",
          noInfo: "No hi ha informació disponible.",
        },
        partial: {
          title: "Hi ha hagut un problema i no s'ha pogut carregar les notes de tipus",
          refresh: "Actualitzar",
          limit: "Límit de clicks superat",
        },
        title: "Error en la càrrega",
        viewDetails: "Veure detalls",
        imageAlt: "Imatge d'error",
        errorToRefresh: "Error en l'acció d'actualitzar la pàgina",
        itemAlreadyExists: "Aquest element ja existeix al històric d'activitat",
        allItemsAlreadyExist: "Tots els elements ja existeixen al històric d'activitat",
        filterNotInitialized:
          "No s'han pogut afegir elements ja que aquesta iniciativa no ha sigut inicialitzada a l'Històric d'Activitat.",
      },
      warning: {
        someItemsAlreadyExist: "Alguns elements ja existien al històric d'activitat i no s'han afegit",
      },
    },
  },
};
